import { each } from 'lodash';
import { ISdcStore, IStoreScope } from './../../../sdc/flux/sdc-store.interface';
/**
 * It would be better to be able to get all nested keys from ISdcStoreState as
 * those correspond directly to state paths. But TS doesn't provide a clear way of doing so.
 * See https://github.com/Microsoft/TypeScript/issues/12290 for info about using typescript
 * function overloads to possibly address.
 *
 * Using `keyOf` only retrieves keys that are immediate children of the interface.
 * Can't use for accessing nested states.
 *
 * e.g. `type TValidStoredStates = keyof ISdcStoreState`;
 *
 * -JYR
 */
type TValidSdcStoreStates =
  | ['students']
  | ['users']
  | ['schools']
  | ['schoolSupports']
  | ['studentSupports']
  | ['flattenedStudents']
  | ['filteredFlattenedStudents']
  | ['filtered', 'flattenedStudents']
  | ['filtered', 'students'];

interface IComponentController {
  $scope: IStoreScope;
  setUi(): void;
  [x: string]: any;
}

export class StoreListenerUtils {
  static $inject: string[] = ['SDCStore'];

  constructor(private SDCStore: ISdcStore) {}

  startListeningAndLoad(componentController: IComponentController, statesToListenTo: TValidSdcStoreStates[]): void {
    componentController.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        componentController.setUi();
        each(statesToListenTo, (state: TValidSdcStoreStates) => {
          this.setListeners(componentController, state);
        });
      }
    });
  }

  private setListeners(componentController: IComponentController, state: TValidSdcStoreStates): void {
    componentController.$scope.$listenTo(this.SDCStore, state, componentController.setUi.bind(componentController));
  }
}
